import React from 'react';
import Styled from 'styled-components';
import { VIEWPORT_SM_MIN } from '../../util/mediaQueries';

export const PageFooter = Styled.div`
  width: 100%;
  max-width: 1000px;
  color: #B0B9C0;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column-reverse;

  @media ${VIEWPORT_SM_MIN} {
    flex-direction: row;
  }
`;

export const PageFooterTextSm = Styled.div`
  margin-top: 20px;
  text-align: center;
  @media ${VIEWPORT_SM_MIN} {
    display: none;
  }
`;

export const PageFooterText = Styled.div`
  display: none;
  @media ${VIEWPORT_SM_MIN} {
    display: block;
  }
`;

export const PageFooterLinks = Styled.div`
  margin: 0 auto;

  @media ${VIEWPORT_SM_MIN} {
    margin-right: 0;
  }

  a, a:hover {
    color: #B0B9C0;
    text-decoration: none;
    font-weight: normal;
    margin: 0 10px;
  }
`;


export default () => (
  <PageFooter>
    <PageFooterTextSm>
      © {new Date().getFullYear()} FINANZCHECK.de
      <br />
      Admiralitätstraße 60, 20459 Hamburg
    </PageFooterTextSm>
    <PageFooterText>
      © {new Date().getFullYear()} FINANZCHECK.de • Admiralitätstraße 60 • 20459
      Hamburg
    </PageFooterText>
    <PageFooterLinks>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://www.finanzcheck.de/datenschutz-sc/"
      >
        Datenschutz
      </a>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://www.finanzcheck.de/impressum/"
      >
        Impressum
      </a>
    </PageFooterLinks>
  </PageFooter>
);
